<div fxLayout="row wrap">
  <div class="teranet-padding" fxFlex="100" fxLayout="column">
    <Teranet-PageTitle [PageTitle]="'Manage Users'"></Teranet-PageTitle>
    <form [formGroup]="userForm" #createform="ngForm" novalidate>
      <div class="mat-elevation-z4">
        <div fxFlex="100">
          <div fxLayout="column" fxLayoutAlign="center stretch">
            <Teranet-ClientTitle [ClientTitle]="'Lookup Users'" [IconName]="'search'"></Teranet-ClientTitle>
          </div>
          <div fxLayout="row wrap" fxLayoutAlign="end">
            <div class="icon-button">
              <button mat-button [routerLink]="['/edituser']">
                <div class="btnicon">
                  <fa-icon icon="plus" id="plus" class="fa-lg" matTooltipPosition="above"></fa-icon>
                </div>
                <div class="btntext">Add</div>
              </button>
            </div>
          </div>
          <div fxLayout.xs="column" fxLayout="row wrap">
            <div class="form-group-flex-column">
              <mat-label>Last name</mat-label>
              <mat-form-field appearance="outline">
                <input matInput
                       type="text"
                       data-lpignore="true"
                       formControlName="lastName" />
              </mat-form-field>
            </div>
            <div class="form-group-flex-column">
              <mat-label>User name</mat-label>
              <mat-form-field appearance="outline">
                <input matInput
                       type="text"
                       data-lpignore="true"
                       name="userName"
                       formControlName="userName" />
              </mat-form-field>
            </div>
            <div class="form-group-flex-column">
              <mat-label>Email</mat-label>
              <mat-form-field appearance="outline">
                <input matInput
                       #txtEmailVal
                       data-lpignore="true"
                       formControlName="email" />
              </mat-form-field>
            </div>
          </div>
          <div fxLayout.xs="column" fxLayout="row wrap">
            <div class="form-group-flex-column">
              <mat-label class="required-field-after">Corporation</mat-label>
              <mat-form-field appearance="outline">
                <mat-select required
                            formControlName="corporation"
                            placeholder="--Please Select--"
                            (selectionChange)="onClientChange()"
                            [disabled]="allClients?.length === 1">
                  <mat-option *ngFor="let client of allClients" [value]="client.id">
                    {{ client.description }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="userForm.get('corporation').hasError('required')">
                  {{ userErrorMessage.CORPORATION_REQUIRED }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-group-flex-column">
              <mat-label>Status</mat-label>
              <mat-form-field appearance="outline">
                <mat-select formControlName="status" (selectionChange)="onStatusChange()">
                  <mat-option value="">All</mat-option>
                  <mat-option *ngFor="let status of statusKeys()" [value]="status">
                    {{ status }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row wrap" fxLayoutAlign="end">
            <button mat-raised-button class="plain-button-lg" (click)="reset()">Clear Criteria</button>
            <button mat-raised-button class="theme-button-lg" (click)="lookup()">Lookup</button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="teranet-padding-relative" fxFlex="100">
    <ngx-spinner [fullScreen]="false"
                 type="ball-clip-rotate-multiple"
                 bdColor="rgba(51,51,51,0.8)"
                 size="medium"
                 color="#fff"></ngx-spinner>
    <Teranet-CustomizedGrid [data]="users"
                            [gridName]="'user-list'"
                            [gridSettings]="gridSettings"
                            [isCopy]="true"
                            [initialGridSettings]="gridDefaultSettings()"
                            [isFinishLoading]="true"
                            [pageName]="'user-list'"
                            (onCopy)="copyUser($event)"></Teranet-CustomizedGrid>
  </div>
</div>
